import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateFlashCouponModel, EditFlashCouponModel, FlashCoupon } from "../../models/inModels/flashcoupon";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";

@Injectable()
export class FlashCouponService {
	private route = '/api/coupons/flash';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<FlashCoupon> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashCoupon)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateFlashCouponModel): Promise<FlashCoupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashCoupon)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditFlashCouponModel): Promise<FlashCoupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashCoupon)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: string): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/flash/flash-coupon-service.ts